import React from "react";
import "./work.css";
const Work = () => {
  return (
    <div>
      <h1 className="w-headline">Work done till now..</h1>
      <div className="w-work">
        <div className="w-workdetail">
          <h2>Helped 15000+ students</h2>
          <h2>Provided 1Lac+ jobs</h2>
          <h2>Reached to 20+ states</h2>
          <h2>10000+ woman statred earning</h2>
        </div>
        <div className="w-workmap">
          <img
            src="https://www.smilefoundationindia.org/images/home/map-1.png"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Work;
